import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { withRouter, useHistory } from "react-router-dom/cjs/react-router-dom";

import {
  SPACE,
  ROUTES,
  messages,
  EMPTY_STRING,
  tipPriceOptions,
  localStorageKeys,
  tipYourShutterb,
  customerConstants,
  eventBookingConstants,
  eventBookingStatus,
} from "../../../../../../../../constants";
import { ReactComponent as CartShopIcon } from "../../../../../../../../assets/icons/cart-shop.svg";
import {
  eventBookingActions,
  customerDashboardActions,
} from "../../../../../../../../redux/actions";
import {
  customToast,
  normalizeValue,
  normalizeEventDates,
} from "../../../../../../../../shared/utility";
import {
  NavigateToPath,
  saveToLocalStorage,
} from "../../../../../../../../system";
import SelectField from "../../../../../../../../shared/components/Fields/SelectField";
import SectionHeader from "../../../../../../../../shared/components/Events/SectionHeader";
import ConfirmationModal from "../../../../../../../../shared/components/Modal/ConfirmationModal";

const TipYourSb = (props) => {
  const history = useHistory();
  const { groupEventId, eventId } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventOrderItems, setEventOrderItems] = useState([]);
  const [isCheckoutClick, setIsCheckoutClick] = useState(null);

  useEffect(() => {
    if (groupEventId) {
      props.getAllEventsByGroupId(groupEventId);
    }
    // eslint-disable-next-line
  }, [groupEventId]);

  useEffect(() => {
    if (props.allEvents.length && eventId) {
      setSelectedEvent(props.allEvents?.find((event) => event.id === eventId));
    }
    // eslint-disable-next-line
  }, [props.allEvents, eventId]);

  useEffect(() => {
    if (selectedEvent) {
      props.getTippedEventDetails(selectedEvent.id);
    }
    // eslint-disable-next-line
  }, [selectedEvent]);

  useEffect(() => {
    if (selectedEvent && props?.myEventsTipSb?.orderItems && eventId) {
      const eventId = selectedEvent.id;
      const event = props.myEventsTipSb;

      const existingEvent = props.customerDashboardCart.find(
        (e) => e.id === eventId
      );

      const updatedItems = event.orderItems.map((item) => {
        const existingOrderItems = existingEvent?.orderItems.find(
          (s) =>
            (s.id === item.id || s.orderItemId === item.id) &&
            s.status === eventBookingStatus.TIP
        );

        return existingOrderItems
          ? {
              ...item,
              ...existingOrderItems,
              status: eventBookingStatus.TIP,
            }
          : {
              ...item,
              status: eventBookingStatus.TIP,
              tipPrice_: 0,
              isCustom: false,
              isTipSelected: false,
            };
      });
      const updatedState = {
        ...event,
        orderItems: updatedItems,
      };

      setEventOrderItems((prev) => {
        const filtered = prev.filter((e) => e.id !== eventId); // remove old event if exists
        return [...filtered, updatedState]; // add updated event
      });
    }
    // eslint-disable-next-line
  }, [props?.myEventsTipSb]);


  let checkoutTimeout;
  const handleClick = (e, isCheckoutClick, isUpdateCart) => {
    e.preventDefault();
    
    if (checkoutTimeout) return;
    checkoutTimeout = setTimeout(() => (checkoutTimeout = null), 2000);

    setIsCheckoutClick(isCheckoutClick);
    handleTipSubmit(false, isCheckoutClick, isUpdateCart);
  };

  const handleTipSubmit = async (
    closeModal,
    isCheckoutClick,
    isUpdateCart = false
  ) => {
    const eventId = selectedEvent?.id;
    if (!eventId) return;

    const currentEvent = eventOrderItems.find((ev) => ev.id === eventId);

    if (!currentEvent) return;

    const selectedTipItems = currentEvent.orderItems.filter(
      (sb) => sb.status === eventBookingStatus.TIP && sb.isTipSelected
    );
    const allValid = selectedTipItems.every((sb) => sb.tipPrice_ > 2);
    const cartHasItems = (props.customerDashboardCart?.length ?? 0) > 0;

    const isCheckoutFlow = isCheckoutClick === tipYourShutterb.CHECKOUT;
    const noValidTipSelection = !allValid || selectedTipItems.length === 0;

    if (!isCheckoutFlow) {
      // Add to cart flow
      if (isUpdateCart && !allValid) {
        customToast(messages.INVALID_TIP_AMOUNT, toast.TYPE.ERROR);
        return;
      }

      if (!isUpdateCart && noValidTipSelection) {
        customToast(
          messages.PLEASE_SELECT_ATLEAST_1_SHUTTERB_WITH_TIP_PRICE_3_DOLLAR_MINIMUM,
          toast.TYPE.ERROR
        );
        return;
      }
    } else if (!cartHasItems && noValidTipSelection) {
      // Checkout flow
      customToast(
        messages.PLEASE_SELECT_ATLEAST_1_SHUTTERB_WITH_TIP_PRICE_3_DOLLAR_MINIMUM,
        toast.TYPE.ERROR
      );
      return;
    }
    // Current event selected orderItems with event detail
    const updatedEvent = {
      ...currentEvent,
      orderItems: selectedTipItems,
    };

    // Existing cart
    let updatedCart = [...(props.customerDashboardCart || [])];

    // Check if event already exists in cart
    const existingIndex = updatedCart.findIndex((ev) => ev.id === eventId);

    if (selectedTipItems.length > 0) {
      if (existingIndex > -1) {
        const existingEvent = updatedCart[existingIndex];

        // merge tip + existing extend
        const extendItems = existingEvent.orderItems.filter(
          (sb) => sb.status === eventBookingStatus.EXTENDED
        );

        updatedCart[existingIndex] = {
          ...existingEvent,
          orderItems: [...selectedTipItems, ...extendItems],
        };
      } else {
        // add new with only tip items
        updatedCart.push(updatedEvent);
      }
    } else if (existingIndex > -1) {
      // If no tip items selected
      const existingEvent = updatedCart[existingIndex];

      // keep only extend items
      const extendItems = existingEvent.orderItems.filter(
        (sb) => sb.status === eventBookingStatus.EXTENDED
      );

      if (extendItems.length > 0) {
        updatedCart[existingIndex] = {
          ...existingEvent,
          orderItems: extendItems,
        };
      } else {
        // no extend items left remove whole event
        updatedCart.splice(existingIndex, 1);
      }
    }

    if (updatedCart.length === 0 && !isUpdateCart) {
      customToast(
        messages.PLEASE_SELECT_ATLEAST_1_SHUTTERB_WITH_TIP_PRICE_3_DOLLAR_MINIMUM,
        toast.TYPE.ERROR
      );
      return;
    }

    if (props.eventAlreadyExist && !closeModal) {
      setShowModal(true);
      return;
    }

    await props.resetEventBooking(true);

    const updatedFormState = normalizeEventDates(updatedCart);
    props.setFormState(updatedFormState);
    props.addToCustomerDashboardCart(updatedFormState);

    saveToLocalStorage(
      localStorageKeys.ACTIVE_TAB,
      eventBookingConstants.TABS_ID.CART
    );
    saveToLocalStorage(customerConstants.NOT_NEW_EVENT, true);
    if (
      localStorage.getItem(customerConstants.CART_PREVIOUS_SCREEN) ===
      customerConstants.EXTEND_TO_CART
    ) {
      localStorage.setItem(
        customerConstants.CART_PREVIOUS_SCREEN,
        customerConstants.EXTEND_AND_TIP_TO_CART
      );
    } else if (
      localStorage.getItem(customerConstants.CART_PREVIOUS_SCREEN) !==
      customerConstants.EXTEND_AND_TIP_TO_CART
    ) {
      localStorage.setItem(
        customerConstants.CART_PREVIOUS_SCREEN,
        customerConstants.TIP_TO_CART
      );
    }

    if (isCheckoutClick === tipYourShutterb.CHECKOUT) {
      setIsCheckoutClick(null);
      NavigateToPath(history, ROUTES.EVENT_BOOKING);
    } else {
      customToast(messages.CART_UPDATED_SUCCESSFULLY, toast.TYPE.SUCCESS);
    }
  };

  // function to handle the events dropdown
  const handleEventSelect = (e) => {
    setSelectedEvent(e);
  };

  // update the eventOrderItems state to store the selected shutterb details
  const updateOrderItems = (eventId, updater) => {
    setEventOrderItems((prev) =>
      prev.map((event) =>
        event.id === eventId
          ? {
              ...event,
              orderItems: event.orderItems.map(updater),
            }
          : event
      )
    );
  };

  // handle the checkbox selection of shutterb
  const handleCheckboxChange = (eventId, index, checked) => {
    updateOrderItems(eventId, (item, idx) =>
      idx === index ? { ...item, isTipSelected: checked } : item
    );
  };

  // handle the price selection of shutterb
  const handleRadioChange = (eventId, index, value) => {
    updateOrderItems(eventId, (item, idx) =>
      idx === index ? { ...item, tipPrice_: value, isCustom: false } : item
    );
  };
  // handle the custom price selection of shutterb
  const handleCustomChange = (eventId, index, value) => {
    const customValue = value === EMPTY_STRING ? 0 : Number(value);
    updateOrderItems(eventId, (item, idx) =>
      idx === index
        ? { ...item, tipPrice_: customValue, isCustom: value !== EMPTY_STRING }
        : item
    );
  };

  const isInCart = props.customerDashboardCart?.some(
    (ev) =>
      ev.id === selectedEvent?.id &&
      ev.orderItems?.some((item) => item.status === eventBookingStatus.TIP)
  );

  return (
    <>
      <div className="container my-events-accordions tip-shutterb-wrapper px-0">
        {props.allEvents?.length > 0 && (
          <SectionHeader
            eventId={eventId}
            groupId={groupEventId}
            itemCount={props.allEvents.length || 0}
            isGroup={props.allEvents.length > 1}
            title={
              props.allEvents.length > 1
                ? props.allEvents[0]?.eventGroupName
                : props.allEvents[0]?.eventName
            }
            className="px-4"
          />
        )}
        <div className="px-2 py-2">
          {props.allEvents?.length > 1 && (
            <div className="col-md-6 col-12">
              <SelectField
                options={props.allEvents ?? []}
                id="select-event"
                label="select an event:"
                placeholder="select an event"
                labelKey="eventName"
                valueKey="id"
                value={selectedEvent}
                setValue={handleEventSelect}
              />
            </div>
          )}

          <div className="row my-3">
            <div className="col-12 mb-4">
              <p className="p-0 m-0 mb-1 text fw-600 text-dark clr-secondary">
                {messages.TIP_YOUR_SHUTTERB_FOR_A_JOB_WELL_DONE}
              </p>
              <p className="mb-0 pr-3 text-content">
                {messages.PLEASE_SELECT_ATLEAST_1_SHUTTERB_TO_TIP}
              </p>
            </div>

            {selectedEvent && eventOrderItems?.length
              ? (() => {
                  const tipItems =
                    eventOrderItems
                      .find((ev) => ev.id === selectedEvent.id)
                      ?.orderItems.filter(
                        (sb) => sb.status === eventBookingStatus.TIP
                      ) || [];

                  return tipItems.length > 0 ? (
                    tipItems.map((sb, index, originalArray) => {
                      const isLastIndex = index !== originalArray.length - 1;
                      return (
                        <React.Fragment key={index}>
                          <div className="col-12 col-md-4 col-xl-3 d-flex align-items-center">
                            <input
                              type="checkbox"
                              name="allEventCheckbox"
                              disabled={sb?.sbUser?.isTip}
                              checked={sb.isTipSelected}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  selectedEvent.id,
                                  index,
                                  e.target.checked
                                )
                              }
                            />
                            <div className="ml-5 d-flex flex-column align-items-center">
                              <div className="tip-shutterb-profile-image">
                                <img
                                  className={`img-fluid rounded-circle obj-fit-cover w-100 h-100 ${
                                    sb?.sbUser?.isTip
                                      ? "tip-extend-shutterb-image"
                                      : EMPTY_STRING
                                  }`}
                                  src={
                                    process.env
                                      .REACT_APP_S3_BASE_URL_PORTFOLIO +
                                    "/" +
                                    sb?.sbUser?.sbPortfolios[0]?.profileImageUrl
                                  }
                                  alt="sb-profile"
                                />
                              </div>
                              <p className="p-0 m-0 mt-2 text fw-600 text-dark clr-secondary text-center">
                                {normalizeValue(sb?.sbUser?.firstName) +
                                  normalizeValue(SPACE) +
                                  normalizeValue(sb?.sbUser?.lastName)}
                              </p>
                            </div>
                          </div>
                          <div className="col-12 col-md-8 col-xl-9 align-content-center mt-3 mt-md-0">
                            <div className="d-block d-xs-flex sb-price-group">
                              {tipPriceOptions.map((option) => (
                                <React.Fragment key={option.id}>
                                  <input
                                    type="radio"
                                    id={`${option.id}-${sb?.sbUser?.id}`}
                                    name={`defaultPrice-${sb?.sbUser?.id}`}
                                    value={option.value}
                                    disabled={sb.isCustom || !sb.isTipSelected}
                                    checked={
                                      sb.isTipSelected &&
                                      !sb.isCustom &&
                                      sb.tipPrice_ === option.value
                                    }
                                    onChange={() =>
                                      handleRadioChange(
                                        selectedEvent.id,
                                        index,
                                        option.value
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor={`${option.id}-${sb?.sbUser?.id}`}
                                  >
                                    {option.label}
                                  </label>
                                </React.Fragment>
                              ))}
                            </div>
                            <input
                              type="number"
                              name={`customPrice-${sb?.sbUser?.id}`}
                              id="customPrice"
                              placeholder="enter custom amount"
                              className="tip-custom-amount"
                              min="3"
                              max="1000"
                              disabled={!sb.isTipSelected}
                              value={sb.isCustom ? sb.tipPrice_ : ""}
                              onChange={(e) => {
                                let value = e.target.value;

                                // Allow empty value so the user can delete everything
                                if (value === "") {
                                  handleCustomChange(
                                    selectedEvent.id,
                                    index,
                                    ""
                                  );
                                  return;
                                }

                                // Prevent non-digit input
                                value = value.replace(/\D/g, "");

                                // Limit to 3 digits max
                                if (value.length > 3) {
                                  value = value.slice(0, 3);
                                }

                                handleCustomChange(
                                  selectedEvent.id,
                                  index,
                                  value
                                );
                              }}
                            />
                          </div>
                          <div
                            className={`col-12 ${
                              isLastIndex ? "my-2" : "my-4"
                            }`}
                          >
                            {isLastIndex && <hr className="custom-hr" />}
                          </div>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <div className="col-12">
                      <p className="label-content-600">
                        The event request has not been accepted by any shutterb
                        yet.
                      </p>
                    </div>
                  );
                })()
              : null}

            <div className="col-12">
              <button
                type="button"
                className="add-to-cart-btn button-common button-outline mb-3 mb-lg-0"
                onClick={(e) =>
                  handleClick(e, tipYourShutterb.ADD_TO_CART, isInCart)
                }
                disabled={!props.myEventsTipSb}
              >
                <CartShopIcon />
                <span className="pl-1">
                  {isInCart ? messages.UPDATE_CART : messages.ADD_TO_CART}
                </span>
              </button>
              <button
                type="button"
                className="button-common button-fill clr-white ml-3 mb-3 mb-lg-0 font-12"
                onClick={(e) => handleClick(e, tipYourShutterb.CHECKOUT)}
                disabled={!props.myEventsTipSb}
              >
                {messages.CHECKOUT}
              </button>
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => {
          props.setEventAlreadyExist(false);
          setShowModal(false);
          setTimeout(() => {
            handleTipSubmit(true, isCheckoutClick);
          }, 0);
        }}
        dialogText="are_you_sure_you_want_to_proceed"
        maxWidth="xs"
        buttonText={"proceed"}
      />
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  userId: state.authentication.userId,
  allEvents: state.customerDashboard.allEvents,
  myEventsTipSb: state.customerDashboard.myEventsExtendSb,
  eventAlreadyExist: state.eventBooking.eventAlreadyExist,
  customerDashboardCart: state.customerDashboard.customerDashboardCart,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getAllEventsByGroupId: (groupEventId) =>
    dispatch(customerDashboardActions.getAllEventsByGroupId(groupEventId)),
  getTippedEventDetails: (eventId) =>
    dispatch(customerDashboardActions.getTippedEventDetails(eventId)),
  addToCustomerDashboardCart: (dataObj) =>
    dispatch({
      type: customerConstants.ADD_TO_CUSTOMER_DASHBOARD_CART,
      data: dataObj,
    }),
  setFormState: (data) => dispatch(eventBookingActions.setFormState(data)),
  setEventAlreadyExist: (data) =>
    dispatch(eventBookingActions.setEventAlreadyExist(data)),
  resetEventBooking: (isTipOrExtend) =>
    dispatch(eventBookingActions.resetEventBooking(isTipOrExtend)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TipYourSb));
